export default {
  // Common titles
  "sweetAlert.common.title.areYouSure": {
    en: "Are you sure?",
    es: "¿Estás seguro?",
  },
  "sweetAlert.common.title.ups": {
    en: "¡Oops!",
    es: "¡Ups!",
  },
  "sweetAlert.common.title.congratulations": {
    en: "Congratulations!",
    es: "¡Enhorabuena!",
  },

  // Common confirm buttons
  "sweetAlert.common.confirmButtonText.save": {
    en: "Save",
    es: "Guardar",
  },
  "sweetAlert.common.confirmButtonText.delete": {
    en: "Delete",
    es: "Eliminar",
  },
  "sweetAlert.common.confirmButtonText.ok": {
    en: "OK",
    es: "OK",
  },
  "sweetAlert.common.confirmButtonText.fix": {
    en: "Fix",
    es: "Corregir",
  },
  "sweetAlert.common.confirmButtonText.agree": {
    en: "Ok",
    es: "Aceptar",
  },

  // Common cancel buttons
  "sweetAlert.common.cancelButtonText.cancel": {
    en: "Cancel",
    es: "Cancelar",
  },
  "sweetAlert.common.cancelButtonText.exit": {
    en: "Close",
    es: "Salir",
  },
  "sweetAlert.common.cancelButtonText.goBack": {
    en: "Go back",
    es: "Volver",
  },

  // Sweet alerts
  "sweetAlert.creditCardUpdated.text": {
    en: "Credit card successfully updated.",
    es: "Tu tarjeta ha cambiado correctamente.",
  },
  "sweetAlert.creditCardUpdateError.title": {
    en: "Oops!",
    es: "¡Ups!",
  },
  "sweetAlert.creditCardUpdateError.text": {
    en: "Your card has been rejected.",
    es: "Tu tarjeta ha sido rechazada.",
  },
  "sweetAlert.quoteExchangeRatesUpdated.title": {
    en: "Exchange rates updated!",
    es: "¡Tipos de cambio actualizados!",
  },
  "sweetAlert.quoteExchangeRatesUpdated.text": {
    en: "Margin has been recalculated according to price.",
    es: "Se ha recalculado el margen respecto al precio.",
  },
  "sweetAlert.howUpdateQuote.title": {
    en: "How do you want to update this proposal?",
    es: "¿Cómo quieres actualizar este presupuesto?",
  },
  "sweetAlert.howUpdateQuote.text": {
    en: "There are costs in the following currencies: __$1__ __$2__",
    es: "Existen costes en las siguientes divisas: __$1__ __$2__",
  },
  "sweetAlert.howUpdateQuote.confirmButtonText": {
    en: "Conserve rate",
    es: "Mantener precio",
  },
  "sweetAlert.howUpdateQuote.cancelButtonText": {
    en: "Conserve margin",
    es: "Mantener margen",
  },
  "sweetAlert.wantRemoveQuote.text": {
    en: "proposal will be removed forever.",
    es: "El presupuesto se eliminará para siempre.",
  },
  "sweetAlert.wantRemoveInvitation.text": {
    en: "You are about to delete the invitation to <strong> __$1__ </strong> in your business __$2__.",
    es: "Estás a punto de borrar la inviación a <strong>__$1__</strong> en la organización __$2__.",
  },
  "sweetAlert.wantRemoveTariff.text": {
    en: "Rate will be removed forever.",
    es: "Se eliminará la tarifa para siempre.",
  },
  "sweetAlert.wantRemoveSection.text": {
    en: "Library section will be removed forever.",
    es: "Se eliminará la sección de la biblioteca para siempre.",
  },
  "sweetAlert.wantHirePackageBranding.title": {
    en: "Branding Pack",
    es: "Pack Branding",
  },
  "sweetAlert.wantHireAdditionalUsers.title": {
    en: "Extra Users",
    es: "Usuarios Adicionales",
  },
  "sweetAlert.wantHireAdditionalUsers.text": {
    en: "You are going to add __$1__ extra users for __$2__",
    es: "Vas a contratar __$1__ usuarios adicionales por __$2__.",
  },
  "sweetAlert.wantCancelPricingTable.text": {
    en: "Take a look to the errors to save pricing table changes.",
    es: "Si no corriges los errores, no se guardarán los cambios que has realizado en la tabla de precios.",
  },
  "sweetAlert.wantGoBackFromPricingTable.text": {
    en: "If you close, changes will not be saved.",
    es: "Si sales de esta ventana no se guardarán los cambios.",
  },
  "sweetAlert.pricingTableIsWrong.title": {
    en: "Saving failed",
    es: "Error al guardar",
  },
  "sweetAlert.pricingTableIsWrong.text": {
    en: "Solve the errors to save your pricing table.",
    es: "Para poder guardar tu tabla de precios debes corregir el error que se ha detectado.",
  },
  "sweetAlert.pricingTableIsRight.title": {
    en: "Would you like to save changes?",
    es: "¿Deseas guardar los cambios?",
  },
  "sweetAlert.pricingTableIsRight.text": {
    en: "The pricing table is ok and you can save the changes.",
    es: "La tabla de precios es correcta y puedes guardar los cambios.",
  },
  "sweetAlert.invitationRemoved.text": {
    en: "Invitation removed.",
    es: "Se ha eliminado la invitación correctamente.",
  },
  "sweetAlert.userRemoved.text": {
    en: "User removed.",
    es: "Se ha eliminado el usuario correctamente.",
  },
  "sweetAlert.wantRemoveUser.text": {
    en: "You are about to remove <strong>__$1__</strong> from the organization __$2__.",
    es: "Estás a punto de eliminar a <strong>__$1__</strong> de la organización __$2__.",
  },
  "sweetAlert.tariffPricesUpdated.title": {
    en: "Rates updated!",
    es: "¡Tarifas actualizadas!",
  },
  "sweetAlert.tariffPricesUpdated.text": {
    en: "All rates updated",
    es: "Se han actualizado los precios de todas tus tarifas",
  },
  "sweetAlert.updateTariffPrices.title": {
    en: "Would you like to update your rates?",
    es: "¿Deseas actualizar los precios de tus tarifas?",
  },
  "sweetAlert.updateTariffPrices.text": {
    en: "Last exchange rate will be used to update your rates",
    es: "Se utilizará la última tasa de cambio para actualizar los precios de tus tarifas",
  },
  "sweetAlert.updateTariffPrices.confirmButtonText": {
    en: "Update rates",
    es: "Actualizar tarifas",
  },
  "sweetAlert.updateTariffPrices.cancelButtonText": {
    en: "Don't update rates",
    es: "No actualizar tarifas",
  },
  "sweetAlert.additionalProductHired.text": {
    en: "Additional feature subscription sucessful.",
    es: "Has contratado esta característica adicional correctamente.",
  },
  "sweetAlert.additionalProductCancelled.text": {
    en: "Additional feature cancelled.",
    es: "Has cancelado esta característica adicional correctamente.",
  },
  "sweetAlert.additionalProductCancelledError.text": {
    en: "An error occurred cancelling, try again or contact our support team.",
    es: "Ha ocurrido un error al cancelar esta característica adicional, inténtalo de nuevo o contacta con nuestro equipo de soporte.",
  },
  "sweetAlert.removeAdditionalUsersError.text": {
    en: "An error occurred removing user licenses. You bhave to delete users or invitations first to reduce your users number.",
    es: "Ha ocurrido un error al dar de baja licencias de usuario. Primero debes eliminar usuarios o invitaciones para poder reducir tu número de licencias.",
  },
  "sweetAlert.additionalProductPreserved.text": {
    en: "You can use Quoters this product as usual.",
    es: "Puedes seguir disfrutando de este producto como hasta ahora.",
  },
  "sweetAlert.additionalProductPreservedError.text": {
    en: "An error occurred while preserving this additional feature, try again or contact our support team.",
    es: "Ha ocurrido un error al mantener esta característica adicional, inténtalo de nuevo o contacta con nuestro equipo de soporte.",
  },
  "sweetAlert.emailVerificationSent.title": {
    en: "Verification email sent!",
    es: "¡Email de verificación enviado!",
  },
  "sweetAlert.emailVerificationSent.text": {
    en: "Check your inbox. Review spam, just in case.",
    es: "Consulta tu bandeja de entrada y comprueba que el email no ha llegado como spam.",
  },
  "sweetAlert.emailVerificationSent.confirmButtonText": {
    en: "Close",
    es: "Cerrar",
  },
  "sweetAlert.templateWillBeDeleted.text": {
    en: "proposal template will be deleted forever.",
    es: "La plantilla se eliminará para siempre.",
  },
  "sweetAlert.contactWillBeDeleted.text": {
    en: "Contact will be deleted forever.",
    es: "El contacto se eliminará para siempre.",
  },
  "sweetAlert.costAssociatedToTariffs.text": {
    en: "This cost may be associated to one or more rates. If you delete it, it will no longer be associated to them.",
    es: "Puede que este coste esté asociado a una o varias tarifas. Si lo eliminas, dejará de estar asociado a dichas tarifas.",
  },
  "sweetAlert.canHaveAssociatedTariffs.text": {
    en: "This folder contains costs that may be associated to some rates. If you delete it, all its contents will also be deleted. ",
    es: "Esta carpeta contiene costes que pueden estar asociados a tarifas. Si la borras, también se borrará todo su contenido.",
  },
  "sweetAlert.resetedPassword.title": {
    en: "Password reset",
    es: "Contraseña Restablecida",
  },
  "sweetAlert.resetedPassword.text": {
    en: "An email was sent to __$1__ with your new password, check your inbox and verify that the email was not received as spam.",
    es: "Se ha enviado un email a __$1__ con tu nueva contraseña, consulta tu bandeja de entrada y verifica que el correo no ha llegado como spam.",
  },
  "sweetAlert.errorResetingPassword.title": {
    en: "Password reset failed",
    es: "Error al restablecer contraseña",
  },
  "sweetAlert.errorResetingPassword.text": {
    en: "There was an error resetting your password. Please contact support: https://help.smartvault.com/hc/en-us/requests/new",
    es: "Surgió un error al restablecer su contraseña. Por favor, contacte con soporte: https://help.smartvault.com/hc/en-us/requests/new",
  },
  "sweetAlert.processingRequest.title": {
    en: "It will take a moment",
    es: "Solo será un segundo...",
  },
  "sweetAlert.processingRequest.text": {
    en: "Processing request.",
    es: "Estamos procesando tu solicitud.",
  },
  "sweetAlert.loadingQuoteEditor.title": {
    en: "Quotering proposal",
    es: "Quoterizando presupuesto",
  },
  "sweetAlert.loadingQuoteEditor.text": {
    en: "3, 2, 1...",
    es: "3, 2, 1...",
  },
  "sweetAlert.generatingPdf.title": {
    en: "Creating PDF",
    es: "Generando documento PDF",
  },
  "sweetAlert.generatingPdf.text": {
    en: "3, 2, 1...",
    es: "3, 2, 1...",
  },
  "sweetAlert.confirmationRequestDefaultDomain.title": {
    en: "Are you sure you want to reset the default domain?",
    es: "¿Seguro que quieres restablecer el dominio por defecto?",
  },
  "sweetAlert.confirmationRequestDefaultDomain.text": {
    en: "Your custom domain will stop working, so proposals won't be accesible anymore with that domain. Your new domain <strong>__$1__</strong>",
    es: "El anterior dominio dejará de funcionar, por lo que no se podrá visualizar la vista pública de los presupuestos enviados con ese dominio. A partir de ahora tu dominio será <strong>__$1__</strong>",
  },
  "sweetAlert.confirmationRequestCustomDomain.title": {
    en: "Are you sure you want to change the domain?",
    es: "¿Seguro que quieres cambiar el dominio?",
  },
  "sweetAlert.confirmationRequestCustomDomain.text": {
    en: "Previous custom domain will stop working, so your clients cannot view proposals on the URLs shared with them. From now on, your custom domain will be <strong>__$1__</strong>",
    es: "El anterior dominio dejará de funcionar, por lo que no se podrá visualizar la vista pública de los presupuestos enviados con ese dominio. Hasta que se valide el nuevo, se utilizará <strong>__$1__</strong>",
  },
  "sweetAlert.confirmationOverWriteQuoteTemplate.title": {
    en: "Are you sure you want to update the template?",
    es: "¿Seguro que quieres actualizar la plantilla?",
  },
  "sweetAlert.confirmationOverWriteQuoteTemplate.text": {
    en: "Template will be updated based on this proposal.",
    es: "La plantilla será actualizada en base a este presupuesto.",
  },
  "sweetAlert.successfullyRequestedDefaultDomain.title": {
    en: "We've made the change!",
    es: "¡Cambio Realizado!",
  },
  "sweetAlert.successfullyRequestedDefaultDomain.text": {
    en: "The custom domain has been reset to the default domain.",
    es: "Se ha reestablecido el dominio por defecto.",
  },
  "sweetAlert.pasteImageLoader.title": {
    en: "Loading image",
    es: "Cargando imagen",
  },
  "sweetAlert.pasteImageLoader.text": {
    en: "Loading image! 3, 2, 1...",
    es: "¡Quoterizando imagen! 3, 2, 1...",
  },
  "sweetAlert.failedPasteImageMaxSize.title": {
    en: "Image size is too big!",
    es: "¡Eso es muy grande!",
  },
  "sweetAlert.failedPasteImageMaxSize.text": {
    en: "For sure is a great photo, but it size exceeds our limits. Remember that the maximum size per image is 3MB.",
    es: "Seguro que es una gran foto, pero pesa mucho. Recuerda que el tamaño máximo por imagen es de 3MB.",
  },
  "sweetAlert.failedPasteImageUpload.title": {
    en: "Ummm... Something went wrong!",
    es: "Ummm... ¡Algo ha fallado!",
  },
  "sweetAlert.failedPasteImageUpload.text": {
    en: "We don't know what, but we will fix it for sure; try again later or, if it doesn't work, reach out to https://help.smartvault.com/hc/en-us/requests/new.",
    es: "No sabemos qué, pero seguro que lo arreglamos. Puedes intentarlo de nuevo más tarde o, si sigue fallando, consultar con nuestro majísimo equipo de soporte en https://help.smartvault.com/hc/en-us/requests/new.",
  },
  "sweetAlert.integrationError.title": {
    en: "Oops! Something is wrong...",
    es: "Ups! Algo no va bien...",
  },
  "sweetAlert.integrationError.text": {
    en: 'An error has occurred with the integration, please <a href="https://help.smartvault.com/hc/en-us/requests/new">contact support</a>',
    es: 'Ha ocurrido un error con la integración, por favor <a href="https://help.smartvault.com/hc/en-us/requests/new">contacte con soporte</a>',
  },
};
